export enum FilterChangeState {
    Apply = 'apply',
    Reset = 'reset',
    DateChanged = 'date-changed',
    Initial = 'initial'
}